import { render, staticRenderFns } from "./SimulateCodeUse.vue?vue&type=template&id=8fc118f4&"
import script from "./SimulateCodeUse.vue?vue&type=script&lang=ts&"
export * from "./SimulateCodeUse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports